import { useMemo } from 'react';

/**
 * Custom hook for filtering crops by type and search query
 */
const matchCropType = (crop, selectedCropType) => {
  const typeName = crop.crop_type?.name || '';
  const typeLower = typeName.toLowerCase();

  // Special case for cover crops (exact match required)
  if (selectedCropType === 'cover_crop') {
    return typeName === 'Cover crop';
  }

  // Case-insensitive match for other types
  return typeLower === selectedCropType.toLowerCase();
};

export const useCropFilter = (crops, selectedCropType, searchQuery) => {
  const filteredCrops = useMemo(() => {
    if (!crops || crops.length === 0) return [];

    return crops.filter((crop) => {
      // Filter by crop type
      if (!matchCropType(crop, selectedCropType)) return false;

      // Filter by search query
      if (!searchQuery) return true;

      const searchLower = searchQuery.toLowerCase();
      const typeName = crop.crop_type?.name || '';
      const typeLower = typeName.toLowerCase();

      return (
        crop.name.toLowerCase().includes(searchLower) ||
        typeLower.includes(searchLower) ||
        (crop.latin_name && crop.latin_name.toLowerCase().includes(searchLower))
      );
    });
  }, [crops, selectedCropType, searchQuery]);

  return filteredCrops;
};



